/**
 * Группировка моделей по полям
 * @param {array} values - Массив backbone.model или любых других объектов поддерживающих метод get
 * @param {string | string[]} keyField - Названия полей значения которых станут ключями групп
 * @returns {object} Объект справочник у котрого поля заданы ключами группировки
 */
export function groupModels(values, keyField) {

    if ( !keyField )
    {return values;}

    let result = {};

    if ( !Array.isArray(keyField) )
    {keyField = [keyField];}

    values.forEach(function(item) {
        let res = result;
        keyField.forEach(function(key,index) {

            let groupKey = item.get(key);
            res.originalField = key;
            if ( !res[groupKey] )
            {res[groupKey] = {};}

            if ( keyField.length - 1 == index )
            {
                if ( !Array.isArray(res[groupKey]) )
                {res[groupKey] = [];}
                res[groupKey].push(item);
            }
            res = res[groupKey];
        });
    });
    return result;
}
